import { render } from "./listaClases.vue?vue&type=template&id=4d675087&scoped=true"
import script from "./listaClases.vue?vue&type=script&lang=js"
export * from "./listaClases.vue?vue&type=script&lang=js"

import "./listaClases.vue?vue&type=style&index=0&id=4d675087&scoped=true&lang=css"

import exportComponent from "C:\\ProductFactory\\analiaperez-landing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d675087"]])

export default __exports__